import { render } from "./Inbox.vue?vue&type=template&id=f6e434ee&scoped=true&ts=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"

import "./Inbox.vue?vue&type=style&index=0&id=f6e434ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e434ee"]])

export default __exports__